var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from "mobx";
import { NOT_LOADED } from "../../Infra/RemoteData";
import { NamedRoutes } from "../NamedRoutes";
export class GlobalAdminAIPartnersListViewModel {
    constructor(container) {
        this.aiPartners = NOT_LOADED;
        this.isRefreshing = false;
        this.aiPartnerAdminService = container.aiPartnerAdminService;
        this.routingUIManager = container.routingUIManager;
        void this.loadAIPartners();
    }
    async loadAIPartners() {
        const result = await this.aiPartnerAdminService.listPartners();
        this.aiPartners = result.results;
    }
    async createAIPartner() {
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_AI_PARTNER_NEW);
    }
    async editAIPartner(partner) {
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_AI_PARTNER_EDIT, { id: partner.id });
    }
    async deleteAIPartner(partner) {
        if (confirm(`Are you sure you want to delete AI partner "${partner.name}"?`)) {
            await this.aiPartnerAdminService.deletePartner(partner.id);
            await this.loadAIPartners();
        }
    }
    async refreshCache() {
        this.isRefreshing = true;
        try {
            await this.aiPartnerAdminService.refreshCache();
            await this.loadAIPartners();
        }
        finally {
            this.isRefreshing = false;
        }
    }
}
__decorate([
    observable
], GlobalAdminAIPartnersListViewModel.prototype, "aiPartners", void 0);
__decorate([
    observable
], GlobalAdminAIPartnersListViewModel.prototype, "isRefreshing", void 0);
